// extracted by mini-css-extract-plugin
module.exports = {"section":"Characteristics_section__KXAU0","header":"Characteristics_header__2zgGu","listMain":"Characteristics_listMain__14cYe","ribbon":"Characteristics_ribbon__A5rvK"};